const spellingTimes = [
    [
        "",
        100
    ],
    [
        "“",
        200
    ],
    [
        "The",
        203
    ],
    [
        "work",
        271
    ],
    [
        "that",
        271
    ],
    [
        "we’re",
        339
    ],
    [
        "doing—democratizing",
        1291
    ],
    [
        "development",
        747
    ],
    [
        "tools,",
        407
    ],
    [
        "making",
        407
    ],
    [
        "it",
        135
    ],
    [
        "possible",
        543
    ],
    [
        "for",
        203
    ],
    [
        "people",
        407
    ],
    [
        "to",
        135
    ],
    [
        "play",
        271
    ],
    [
        "and",
        203
    ],
    [
        "experience",
        679
    ],
    [
        "more",
        271
    ],
    [
        "stories",
        475
    ],
    [
        "and",
        203
    ],
    [
        "games—has",
        1011
    ],
    [
        "limitless",
        1011
    ],
    [
        "impact",
        407
    ],
    [
        "on",
        135
    ],
    [
        "what",
        271
    ],
    [
        "our",
        203
    ],
    [
        "society",
        475
    ],
    [
        "will",
        271
    ],
    [
        "become.",
        675
    ],
    [
        "I",
        367
    ],
    [
        "want",
        271
    ],
    [
        "my",
        435
    ],
    [
        "children",
        743
    ],
    [
        "to",
        335
    ],
    [
        "walk",
        271
    ],
    [
        "into",
        271
    ],
    [
        "a",
        67
    ],
    [
        "world",
        339
    ],
    [
        "that",
        271
    ],
    [
        "is",
        135
    ],
    [
        "different",
        611
    ],
    [
        "than",
        271
    ],
    [
        "the",
        203
    ],
    [
        "one",
        203
    ],
    [
        "that",
        271
    ],
    [
        "I",
        67
    ],
    [
        "walked",
        407
    ],
    [
        "into,",
        339
    ],
    [
        "as",
        135
    ],
    [
        "I",
        367
    ],
    [
        "want",
        771
    ],
    [
        "the",
        203
    ],
    [
        "same",
        271
    ],
    [
        "for",
        203
    ],
    [
        "yours.”",
        207
    ],
    [
        "",
        400
    ]
];

export default spellingTimes;